import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DataImportComponent } from './data-import.component';
import { ImportConfigComponent } from './import-config.component';
import { ImportErrorsComponent } from './import-errors.component';
import { ImportResultComponent } from './import-result.component';

const routes: Routes = [
  { path: '', component: DataImportComponent, data: { title: 'Import Data' } },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DataImportRoutingModule {}
const components = [
  DataImportComponent,
  ImportConfigComponent,
  ImportErrorsComponent,
  ImportResultComponent,
];

@NgModule({
  imports: [DataImportRoutingModule, VmeCommonModule, VmeDirectivesModule, VmePipesModule],
  declarations: [...components],
  exports: [...components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DataImportModule {}
